<template>
  <div>
    <ts-loading-banner :loading="loading">
      <table class="ts-w-full ts-mt-4">
        <thead>
          <tr class="ts-bg-blue-100">
            <th class="ts-text-sm ts-py-1 ts-px-2">
              {{ $t('task.productName') }}
            </th>
            <th class="ts-text-sm ts-py-1 ts-px-2">
              {{ $t('task.uom') }}
            </th>
            <th class="ts-text-sm ts-text-center ts-py-1 ts-px-2">
              {{ $t('task.quantity') }}
            </th>
            <th class="ts-text-sm ts-py-1 ts-px-2">
              {{ $t('task.remark') }}
            </th>
            <th class="ts-text-sm ts-py-1 ts-px-2">
              {{ $t('task.borrowing#') }}
            </th>
            <th class="ts-text-sm ts-py-1 ts-px-2 ts-w-24 ts-text-center">
              {{ $t('actions') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(r, index) in resources">
            <tr v-if="index !== editIndex">
              <td class="ts-text-sm ts-py-1 ts-px-2 ts-w-56">
                {{ r.product_name_en }}
              </td>
              <td class="ts-text-sm ts-py-1 ts-px-2 ts-w-24">
                {{ r.uom_name_en }}
              </td>
              <td class="ts-text-sm ts-py-1 ts-px-2 ts-w-24 ts-text-center">
                {{ r.quantity }}
              </td>
              <td class="ts-text-sm ts-py-1 ts-px-2">{{ r.remark }}</td>
              <td class="ts-text-sm ts-py-1 ts-px-2 ts-w-40">
                {{ r.sfo_number }}
              </td>
              <td
                class="ts-text-sm ts-py-1 ts-px-2 ts-text-center ts-space-x-2"
              >
                <a
                  href="#"
                  class="ts-text-blue-600"
                  @click.prevent="onEdit(index, r)"
                >
                  <i class="fas fa-edit"></i>
                </a>
                <a-popconfirm
                  placement="leftTop"
                  :title="$t('are_you_sure_to_delete')"
                  :ok-text="$t('yes')"
                  :cancel-text="$t('no')"
                  @confirm="deleteRecord(r)"
                >
                  <a href="#" :disabled="r._deleting" class="ts-text-red-500">
                    <i class="fas fa-circle-notch spin" v-if="r._deleting"></i>

                    <i class="fas fa-trash-alt" v-else></i>
                  </a>
                </a-popconfirm>
              </td>
            </tr>
            <tr v-if="index === editIndex">
              <td class="ts-text-sm ts-py-1 ts-px-2" valign="top">
                <Select
                  v-model="model.product_id"
                  :filterable="true"
                  style="width:100%"
                  @on-change="onProductChange()"
                >
                  <Option
                    v-for="item in products"
                    :value="item.product_id"
                    :key="item.product_id + item.sfo_id"
                    >{{ item.product_name_en }}</Option
                  >
                </Select>
                <div v-if="errors.has('product_id')" class="ts-text-red-600">
                  {{ errors.first('product_id') }}
                </div>
              </td>
              <td
                class="ts-font-roboto ts-text-base ts-py-1 ts-px-2"
                valign="top"
              >
                <Select
                  v-model="model.uom_id"
                  :filterable="true"
                  style="width:100%"
                  @on-change="onGetPrice()"
                >
                  <Option
                    v-for="item in uomList"
                    :value="item.uom_id"
                    :key="item.uom_id"
                    >{{ item.uom_name_en }}</Option
                  >
                </Select>
                <div v-if="errors.has('uom_id')" class="ts-text-red-600">
                  {{ errors.first('uom_id') }}
                </div>
              </td>
              <td
                class="ts-text-base ts-text-center ts-py-1 ts-px-2 ts-w-24"
                valign="top"
              >
                <Input
                  type="number"
                  v-model.number="model.quantity"
                  placeholder="Quantity"
                  style="width: 100%"
                />
                <div v-if="errors.has('quantity')" class="ts-text-red-600">
                  {{ errors.first('quantity') }}
                </div>
              </td>
              <td
                class="ts-text-base ts-text-left ts-py-1 ts-px-2"
                valign="top"
                colspan="2"
              >
                <Input
                  type="text"
                  v-model="model.remark"
                  placeholder="Remark"
                  style="width: 100%"
                />
              </td>
              <td class="ts-text-center ts-space-x-2" valign="top">
                <button
                  class="ts-px-3 ts-py-1 ts-rounded ts-bg-blue-600 ts-text-white"
                  @click.prevent="onUpdateProductReport"
                >
                  <i class="far fa-save"></i>
                </button>
                <button
                  class="ts-px-3 ts-py-1 ts-rounded ts-duration-150 ts-bg-red-500 ts-transition-all hover:ts-bg-red-600 hover:ts-text-white"
                  @click.prevent="cancelEdit"
                >
                  <i class="fas fa-times"></i>
                </button>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </ts-loading-banner>
  </div>
</template>

<script>
import {
  productDetailReport,
  destroyProductReport,
  updateProductReport
} from '@/api/project-mgt/task-profile'
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
export default {
  props: ['reportDate'],
  data() {
    return {
      errors: new Errors(),
      loading: false,
      editIndex: undefined,
      products: [],
      uom: [],
      resources: [],
      model: {
        id: '',
        product_id: undefined,
        uom_id: '',
        unit_price: 0,
        remark: '',
        sfo_id: '',
        quantity: 0
      }
    }
  },
  computed: {
    uomList() {
      let findProduct = this.products.find(
        p => p.product_id == this.model.product_id
      )
      if (findProduct) {
        return this.uom.filter(u => u.uom_cat_id == findProduct.uom_cat_id)
      }
      return []
    }
  },
  created() {
    this.fetchProduct()
  },
  methods: {
    ...mapActions('projectMgt/taskProfile', ['formViewModel']),
    fetchProduct() {
      this.loading = true
      productDetailReport(this.$route.params.id, {
        params: {
          date: this.reportDate
        }
      })
        .then(({ data }) => {
          this.resources = data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => (this.loading = false))
    },
    deleteRecord(record) {
      this.loading = true
      destroyProductReport(record.id)
        .then(response => {
          this.$toasted.success(response.message)
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => (this.loading = false))
    },
    fetchProductEdit(sfoId) {
      this.loading = true
      this.formViewModel({
        fnName: 'product,uom',
        sfoId: sfoId,
        action: 'update'
      })
        .then(response => {
          this.products = response.data.product
          this.uom = response.data.uom
        })
        .finally(() => (this.loading = false))
    },
    onEdit(index, row) {
      this.editIndex = index
      this.fetchProductEdit(row.sfo_id)
      this.model.id = row.id
      this.model.product_id = row.product_id
      this.model.uom_id = row.uom_id
      this.model.unit_price = row.unit_price
      this.model.remark = row.remark
      this.model.quantity = row.quantity
      this.model.sfo_id = row.sfo_id
    },
    onGetPrice() {
      if (this.model.uom_id) {
        this.loading = true
        this.formViewModel({
          fnName: 'getSalePrice',
          product_id: this.model.product_id,
          uom_id: this.model.uom_id
        })
          .then(response => {
            this.model.unit_price = response.data.getSalePrice[0].sale_price
          })
          .finally(() => (this.loading = false))
      }
    },
    onProductChange() {
      if (this.model.product_id === undefined) return
      let findProduct = this.products.find(
        p => p.product_id == this.model.product_id
      )
      let defaultUom = this.uom.find(
        u => u.uom_cat_id == findProduct.uom_cat_id && u.is_default == true
      )
      this.model.uom_id = defaultUom.uom_id

      // get sfo id
      const sfo = this.products.find(
        el => el.product_id == this.model.product_id
      )
      this.model.sfo_id = sfo.sfo_id

      this.onGetPrice()
    },
    cancelEdit() {
      this.editIndex = undefined
    },
    onUpdateProductReport() {
      this.loading = true
      this.errors.clear()
      updateProductReport({
        id: this.model.id,
        data: this.model
      })
        .then(response => {
          this.$toasted.success(response.message)
          this.editIndex = undefined
          this.fetchProduct()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.loading = false))
    }
  }
}
</script>
